import classNames from "classnames";
import React, { useEffect } from "react";
import { lookupColourString } from "../lookups";
import { SecondaryWidthClassName, SectionPaddingClassName } from "../styles";

export const FormComponent: React.FC<{
  controlInformation?: ReadonlyArray<{
    name: string | null;
    controlInformation?: Record<string, unknown> | null;
  }>;
  backgroundColour: Queries.GraphCMS_Colour | null;
}> = ({ controlInformation, backgroundColour }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://webforms.pipedrive.com/f/loader";
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  if (!controlInformation) {
    return null;
  }
  return (
    <section
      data-component="Form Component"
      className={classNames(
        "page-grid max-width relative",
        SectionPaddingClassName,
        lookupColourString(backgroundColour, "bg"),
        "md:gap-y-40px",
      )}
    >
      {controlInformation?.map((form) => {
        if (form.controlInformation) {
          return (
            <div
              key={form.name}
              className={classNames(
                SecondaryWidthClassName,
                form.controlInformation.formType === "pipedrive" &&
                  "pipedriveWebForms",
                "flex justify-center",
              )}
              data-pd-webforms={`https://webforms.pipedrive.com/f/${
                form.controlInformation.id as string
              }`}
            ></div>
          );
        }
        return undefined;
      })}
    </section>
  );
};
